// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__o7ibw","footerButton":"styles_footerButton__zQiIz","separator":"styles_separator__ZJM63"};